import PropTypes from 'prop-types'
import React, { useState, useEffect, useRef } from "react"
import { Row, Col, Card, Alert, CardBody, Button, Modal, ModalBody, Label } from "reactstrap";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

// import Utils from '../Utility';
import Utils from '../Utility';

// actions
import { post, upload, put, get } from '../../helpers/api_helper';
import { toast } from 'react-toastify';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Resizer from "react-image-file-resizer";
import Multiselect from 'multiselect-react-dropdown';



const AddProperty = props => {
    const { user, data, setLoading, loading, role, getData, setIsAdd, currentData, setCurrentData, thumb, setThumb, file, setFile, setBanners, banners, setTag, tag } = props;
    // const [file, setFile] = useState(null);
    const [files, setFiles] = useState([]);
    const imageInput = useRef();
    const cropper = useRef();
    const [descContent, setDescContent] = useState(null);
    // const [banners, setBanners] = useState([]);
    const [desc, setDesc] = useState("");
    const [cropperModal, setCropperModal] = useState(false);
    const [checkbox, setCheckbox] = useState(false);
    const [currentFile, setCurrentFile] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const [fileType, setFileType] = useState('thumb');
    const cropperRef = useRef();
    const imagePickerRef = useRef();
    const [catSet, setCatSet] = useState(undefined);
    const [page, setPage] = useState([]);
    // const [select, setSelect] = useState([]);
    // const []

    // console.log("banner", banners);

    const handleValidSubmit = async (e, v) => {
        if (!loading) {
            setLoading(true);
            let body = {
                ...v,
                token: user?.token
            }
            console.log("check body=====>", body);
            if (currentData?._id) {
                body = {
                    ...body,
                    seoId: currentData?._id
                }
                put("/seo", body)
                    .then(res => {
                        setLoading(false);
                        if (res?.statusCode == 200) {
                            toast.success(res?.message);
                            closeTab()
                        } else
                            toast.error("" + res?.error);
                    })
                    .catch(err => {
                        setLoading(false);
                        console.error("error while updating data", err);
                        toast.error("Something Went Wrong!");
                    })
            } else {
                post("/seo", body)
                    .then(res => {
                        console.log("check blog data submit res=====>", res);
                        setLoading(false);
                        if (res?.statusCode == 200) {
                            toast.success(res?.message);
                            closeTab()
                        } else {
                            toast.error(res?.error);
                        }
                    })
                    .catch(err => {
                        setLoading(false);
                        console.error("Error while adding blog", err);
                        toast.error("Something Went Wrong!");
                    })
            }
        }
    }

    const closeTab = () => {
        props.setCurrentData(null);
        props?.close(false)
    }

    useEffect(() => {
        getPage();
    }, [user])

    const getPage = () => {
        get("/pages", { token: user?.token })
            .then(res => {
                if (res?.statusCode == 200) {
                    setPage(res?.data);
                }
            })
            .catch(err => {
                toast.error("Something Went Wrong!");
            });
    }

    const handleChangeInput = (list) => {
        let temp = []
        list?.map((item) => (
            temp.push({ id: item?.id, name: item?.name })
        ))
        setCatSet(temp)
        console.log("ddad tags", list);
        setSelectedTags(temp);
    }

    return (
        <React.Fragment>
            <div>
                <h4 className="card-title mb-4">{currentData ? 'Update ' + role : 'Add a ' + role}</h4>
                <Card>
                    <CardBody>
                        <Row>
                            <Col lg={12} md={12}>
                                <div className="text-center close_button" style={{ marginLeft: 'auto' }}>
                                    <button color="primary" className='btn btn' onClick={() => { closeTab() }} style={{ backgroundColor: Utils.themeColor, border: 'none', color: Utils.textColor }}>
                                        Close
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        <AvForm
                            className="form-horizontal"
                            onValidSubmit={(e, v) => { handleValidSubmit(e, v) }}>
                            {/* <div className='divider'></div> */}
                            {/* <h4 style={{ textAlign: 'center' }}><br /> SEO Purpose</h4> */}

                            <Row>
                                <Col md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name='pageId'
                                            label='Page'
                                            value={currentData?.pageId}
                                            className="form-control"
                                            type='select'
                                            required
                                        >
                                            <option value="">Select Page</option>
                                            {page?.map((item) => (
                                                <option value={item?._id}>{item?.title}</option>
                                            ))}
                                        </AvField>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name='metaTitle'
                                            label='Title'
                                            value={currentData?.metaTitle}
                                            placeholder='Enter Meta Title'
                                            className="form-control"
                                            type='text'
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className='form-group mb-4'>
                                        <AvField
                                            name='metaKey'
                                            label='Meta Keyword'
                                            value={currentData?.metaKey}
                                            placeholder='Enter meta keyword'
                                            className="form-control"
                                            required
                                            type='text'
                                        />
                                    </div>

                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="robotsLink"
                                            label={"Robots URL"}
                                            value={currentData?.robotsLink}
                                            className="form-control"
                                            placeholder={`Enter Url`}
                                            type="url"
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className='form-group mb-4'>
                                        <AvField
                                            name='metaDesc'
                                            label='Meta Description'
                                            value={currentData?.metaDesc}
                                            placeholder='Enter meta description'
                                            className='form-control'
                                            type='textarea'
                                            row={2}
                                            required
                                        />
                                    </div>
                                </Col>
                            </Row>

                            {/* Geograph */}
                            <h4 style={{ textAlign: 'center' }}>Geograph</h4>
                            <Row>
                                <Col md={6}>
                                    <div className='form-group mb-4'>
                                        <AvField
                                            name='ogTitle'
                                            label='OG Title'
                                            value={currentData?.ogTitle}
                                            placeholder='Enter title'
                                            className='form-control'
                                            type='text'
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="ogurl"
                                            label={"OG URL"}
                                            value={currentData?.ogurl}
                                            className="form-control"
                                            placeholder={`Enter url`}
                                            type="url"
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className='form-group mb-4'>
                                        <AvField
                                            name='ogType'
                                            label='OG Type'
                                            value={currentData?.ogType}
                                            placeholder='Enter type'
                                            className='form-control'
                                            type='text'
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className='form-group mb-4'>
                                        <AvField
                                            name='ogLocation'
                                            label='OG Location'
                                            value={currentData?.ogLocation}
                                            placeholder='Enter location'
                                            className='form-control'
                                            type='text'
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className='form-group mb-4'>
                                        <AvField
                                            name='ogDesc'
                                            label='OG Description'
                                            value={currentData?.ogDesc}
                                            placeholder='Enter description'
                                            className='form-control'
                                            type='textarea'
                                            row={2}
                                            required
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <h4 style={{ textAlign: 'center' }}>Truth Used</h4>

                            <Row>
                                <Col md={6}>
                                    <div className='form-group mb-4'>
                                        <AvField
                                            name='seoTitle'
                                            label='Title'
                                            value={currentData?.seoTitle}
                                            placeholder='Enter title'
                                            className='form-control'
                                            type='text'
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className='form-group mb-4'>
                                        <AvField
                                            name='seoCondTag'
                                            label='Conditional Tag'
                                            value={currentData?.seoCondTag}
                                            placeholder='Enter conditional tag'
                                            className='form-control'
                                            type='text'
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className='form-group mb-4'>
                                        <AvField
                                            name='seoDesc'
                                            label='Description'
                                            value={currentData?.seoDesc}
                                            placeholder='Enter description'
                                            className='form-control'
                                            type='textarea'
                                            row={2}
                                            required
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <div className="text-center mt-4">
                                {currentData ?
                                    <button type="submit" style={{ border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor }}>
                                        Update {role}
                                    </button>
                                    :
                                    <button type="submit" style={{ border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor }}>
                                        Add {role}
                                    </button>
                                }
                            </div>
                        </AvForm>
                    </CardBody>
                </Card>
            </div>
        </React.Fragment >
    )
}

AddProperty.propTypes = {
    error: PropTypes.any,
    success: PropTypes.any,
    companyError: PropTypes.func,
    companySuccess: PropTypes.func,
    createCompany: PropTypes.func,
    updateCompany: PropTypes.func
}

const mapStatetoProps = state => {
    const { user } = state.Profile;
    return { user }
}

export default withRouter(
    connect(mapStatetoProps, {})(AddProperty)
)
